<div class="master-form">
  <form novalidate [formGroup]="cashierTransForm">
    <div class="row">
      <div class="col-sm-12 col-md-2">
        <div *ngIf="transType !=63" class="form-group">

          <label>{{ "TransDate" | translate }}</label>
          <div *ngIf="!isVirtual ">
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="{{ 'DATEFORMAT' | translate }}" [value]="
                  cashierTransForm.get('transDate').value | date : 'dd/MM/yyyy'
                " disabled />
            </div>
          </div>
          <div *ngIf="isVirtual">
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="{{ 'DATEFORMAT' | translate }}" formControlName="transDateNgb"
                ngbDatepicker #FDD="ngbDatepicker" />
              <div class="input-group-addon" (click)="FDD.toggle()">
                <i class="fa fa-calendar"></i>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="transType ==63" class="form-group">

          <label>{{ "TransDate" | translate }}</label>
          <!-- <div *ngIf="!isVirtual ">
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="{{ 'DATEFORMAT' | translate }}" [value]="
                  cashierTransForm.get('transDate').value | date : 'dd/MM/yyyy'
                " disabled />
            </div>
          </div> -->
          <div>
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="{{ 'DATEFORMAT' | translate }}" formControlName="transDateNgb"
                ngbDatepicker #FDD="ngbDatepicker" />
              <div class="input-group-addon" (click)="FDD.toggle()">
                <i class="fa fa-calendar"></i>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "CashAmmount" | translate }}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="cashAmmount"
            [attr.disabled]="true" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2" [ngClass]="{ disabledDiv: openCheque == 2 }">
        <div class="form-group">
          <label>{{ "ChequeAmmount" | translate }}</label>
          <div class="input-group input-group-sm">
            <!-- (mouseenter)="setCashAmmount('cheque',cheque.value)" -->
            <input numbersOnly class="form-control form-control-sm" formControlName="chequeAmmount" #cheque
              (keyup)="setCashAmmount('cheque', cheque.value)"
              (change)="chequeDetail(cheque.value, chequeDetailPopup)" />
            <div *ngIf="!cheque.value|| cheque.value==0" class="input-group-addon"
              (click)="chequeDetail(cheque.value, chequeDetailPopup)">
              <i class="fa fa-file-o"></i>
            </div>
          </div>
        </div>
        <div class="form-group">
          <label class="custom-control custom-checkbox">
            <input type="checkbox" #showCheque class="custom-control-input"
              (click)="showChequePopup(showCheque.checked, chequeDetailPopup)" />
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{
              "CHEQUE" | translate
              }}</span>
          </label>
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "VisaAmmount" | translate }}</label>
          <div class="input-group input-group-sm">
            <!-- (mouseenter)="setCashAmmount('visa',visa.value)" -->
            <input numbersOnly class="form-control form-control-sm" formControlName="visaAmmount" #visa
              (keyup)="setCashAmmount('visa', visa.value)" (change)="visaDetail(visa.value, visaDetailPopup)" />
            <div *ngIf="!visa.value|| visa.value==0" class="input-group-addon"
              (click)="visaDetail(visa.value, visaDetailPopup)">
              <i class="fa fa-file-o"></i>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label class="custom-control custom-checkbox">
            <input type="checkbox" #showVisa class="custom-control-input"
              (click)="showVisaPopup(showVisa.checked, visaDetailPopup)" />
            <span class="custom-control-indicator"></span>
            <span class="custom-control-description">{{
              "VISA" | translate
              }}</span>
          </label>
        </div>
      </div>
      <!-- *ngIf="transType != 39" -->
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "TotalAdvancePayment" | translate }}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="totalAdvancePayment"
            [attr.disabled]="true" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <div class="row" [ngClass]="{disabledDiv:showLoyaltyPoint}">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" #hasDiscount [checked]="
                  showDiscount ||
                  (transType == 39 && activatePublicSaleDiscount == 2)
                " [disabled]="(transType == 39 && activatePublicSaleDiscount == 2)" class="custom-control-input"
                (change)="showDiscountOptions(hasDiscount.checked)" />
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{
                "hasDiscount" | translate
                }}</span>
            </label>
          </div>
          <!-- *ngIf="transType != 39"  sayed -->
          <div class="row" [ngClass]="{
              disabledDiv:
                cashierTransForm.get('totalAdvancePayment').value == null
            }">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" class="custom-control-input" #hasDownPayment [checked]="showDownPayment"
                (change)="showSettleAdvancePayment(hasDownPayment.checked)" />
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{
                "HASDOWNPAYMENT" | translate
                }}</span>
            </label>
          </div>
          <div class="row" [hidden]="!jsonFormSetting.hasCopon.display">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" #HasCopon [checked]="showCopon" class="custom-control-input"
                (change)="couponDetail(couponDetailPopup)" />
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{
                "HASCOPON" | translate
                }}</span>
            </label>
          </div>
          <div class="row" *ngIf="transType != 39" [ngClass]="{disabledDiv:cashierTransForm.get('totalLoyaltyPoint').value == null}">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" #HasLoyaltyPoint [checked]="showLoyaltyPoint" class="custom-control-input"
                (change)="LoyaltyPointDetail()" />
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{
                "تسويه من نقاط الولاء" | translate
                }}</span>
            </label>
          </div>
          <div class="row">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" #bankTransfer class="custom-control-input"
                (change)="addbankTransfer(bankTransfer.value)" />
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{
                "اضافة تحويل بنكي وارد" | translate
                }}</span>
            </label>
          </div>
          <div class="row">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" #BankTrans [checked]="showBankTrans" class="custom-control-input"
                (change)="hasBankTrans(BankTrans.checked)" />
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{
                "SETTLEBANKTRANSFER" | translate
                }}</span>
            </label>
          </div>
          <div class="row">
            <label class="custom-control custom-checkbox">
              <input type="checkbox" #payWithDocrr [checked]="payWithDoc" class="custom-control-input"
                (change)="showpayWithDoc(payWithDocrr.checked)">
              <span class="custom-control-indicator"></span>
              <span class="custom-control-description">{{
                "MEMOSDOCTOR" | translate
                }}</span>
            </label>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "SETTLEBANKTRANSFORMER" | translate }}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="settleBankTransformer"
            [attr.disabled]="true" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "HANDRECEIPT" | translate }}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="handReceipt" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "REMAININGFROMOTHERVISITS" | translate }}</label>
          <input [attr.disabled]="true" numbersOnly class="form-control form-control-sm"
            formControlName="remainingFromOtherVisits" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{'ANOTHERSETTLEMENT'|translate}}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="anotherSettlement"
            [attr.disabled]="true" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2" *ngIf="transType == 39">
        <div class="form-group">
          <label>{{ "VALUEOFCASHRECEIVED" | translate }}</label>
          <input (change)="getReceivedforSaleTpublic()" [(ngModel)]="valueOfCashReceived"
            [ngModelOptions]="{ standalone: true }" name="valueOfCashReceived" numbersOnly />
        </div>
      </div>

      <div class="col-sm-12 col-md-2" *ngIf="transType == 39">
        <div class="form-group">
          <label>{{ "RESIDUAL" | translate }}</label>
          <input [attr.disabled]="true" numbersOnly class="form-control form-control-sm" formControlName="residual" />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="showCopon">
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "TOTALCOUPONVALUE" | translate }}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="couponAmmount"
            [attr.disabled]="true" />
        </div>
      </div>
    </div>
    <div class="row" *ngIf="showLoyaltyPoint" [ngClass]="{disabledDiv:showLoyaltyPoint}">
      <div class="col-sm-4 col-md-2">
        <div class="form-group">
          <label>{{ "TOTALLOYALTYPOINT" | translate }}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="totalLoyaltyPoint"
          [attr.disabled]="true"/>
        </div>
      </div>
      <div class="col-sm-4 col-md-2">
        <div class="form-group">
          <label>{{ "LOYALTYPOINTSETTLED" | translate }}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="settlmentLoyaltyPoint"
          [attr.disabled]="true" />
        </div>
      </div>
       
    </div>
    <div class="row">
      <!-- *ngIf="transType != 39" sayed -->
      <div class="col-sm-12 col-md-2" [hidden]="!showDownPayment">
        <div class="form-group">
          <!--  (mouseenter)="changeSettleValue()" -->
          <label>{{ "SETTLEADVANCEPAYMENT" | translate }}</label>
          <input numbersOnly class="form-control form-control-sm" (keyup)="changeSettleValue()"
            formControlName="settleAdvancePayment" />
        </div>
      </div>
      <!--<div class="col-sm-2" [hidden]="true">
        <div class="form-group">
          <label>{{'NetAdvancePayment' | translate}}</label>
          <input numbersOnly class="form-control form-control-sm" formControlName="netAdvancePayment" />
        </div>
      </div>-->
      <div class="col-sm-12 col-md-2" [hidden]="!showDiscount && transType != 39" [ngClass]="{disabledDiv:showLoyaltyPoint}">
        <div class="form-group">
          <sanabel-selectize appcode="46" formControlName="discountType" #discountTypeSelectize
            [disabled]="transType == 39 && activatePublicSaleDiscount == 2"
            (clicked)="onDiscountTypeSelectizeClicked($event)">
          </sanabel-selectize>
        </div>
      </div>
      <div class="col-sm-12 col-md-2" [hidden]="!showDiscount && transType != 39"  
        [ngClass]="{ disabledDiv: (discountType == 2 ||showLoyaltyPoint)}">
        <div class="form-group">
          <sanabel-selectize appcode="40" formControlName="percentOrValue" #percentOrValueSelectize
            [disabled]="transType == 39 && activatePublicSaleDiscount == 2" (clicked)="onPVSelectizeClicked($event)">
          </sanabel-selectize>
        </div>
      </div>
      <div class="col-sm-12 col-md-2" [hidden]="!showDiscount && transType != 39">
        <div class="form-group">
          <!-- (mouseenter)="onDiscountValueChanged(discount.value)" -->
          <label>{{ "discountPercent" | translate }}</label>
          <input numbersOnly #discount [ngClass]="{ disabledDiv: discountType == 2 }" [disabled]="
              (transType == 39 && activatePublicSaleDiscount == 2) ||
              transType == 63||showLoyaltyPoint
            " (keyup)="onDiscountValueChanged(discount.value)" formControlName="discountValue"
            class="form-control form-control-sm" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2" [hidden]="!showDiscount" [ngClass]="{disabledDiv:showLoyaltyPoint}">
        <div class="form-group">
          <sanabel-selectize appcode="1053" [SearchKeys]="{ hasDisCount: 1 }" formControlName="cshDiscountsCode"
            #discountDiscriptionSelectize>
          </sanabel-selectize>
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "EXECUTEDDOCTOR" | translate }}</label>
          <sanabel-selectize appcode="1014" [simpleView]="true" [SearchKeys]="{MedicalType: 6}" formControlName="executedByDocId">
          </sanabel-selectize>
        </div>
      </div>
      <div *ngIf="transType==63" class="col-sm-12 col-md-2 col-lg-2">
        <label>{{ "USERNAME" | translate }}</label>
        <sanabel-selectize appcode="1045" [simpleView]="true" [SearchKeys]="{Level: cashierCode}"
          formControlName="returnSecLoginId">
        </sanabel-selectize>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{'NOTES' | translate}}</label>
          <input class="form-control form-control-sm" formControlName="notes" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2" [hidden]="showDollarRate == 2">
        <div class="form-group">
          <label for="conversionFactor">{{
            "CONVERSIONFACTOR" | translate
            }}</label>
          <input type="number" class="form-control form-control-sm" formControlName="dollarRate" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{ "PAYEDVALUE" | translate }}</label>
          <input (change)="payedValueEntered()" [(ngModel)]="totalPayedValue" [ngModelOptions]="{ standalone: true }"
            name="totalPayedValue" numbersOnly />
        </div>
      </div>
    </div>
    <div class="row" [hidden]="!payWithDoc">
      <div class="col-sm-12 col-md-2" [hidden]="!payWithDoc">
        <div class="form-group">
          <sanabel-selectize appcode="1014" [disabled]="memoSerial > 0" formControlName="memoDoc"
            #DoctorSelectizeSelectize (clicked)="onDoctorSelectizeClicked($event)">
          </sanabel-selectize>
        </div>
      </div>
      <div class="col-sm-12 col-md-2" [hidden]="!payWithDoc">
        <div class="form-group">
          <sanabel-selectize appcode="1085" [disabled]="memoSerial > 0" formControlName="notifCode"
            #onMemoSerialSelectize (clicked)="onMemoSerialClicked($event)">
          </sanabel-selectize>
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{'MEMOSDOCTOR' | translate}}</label>
          <input numbersOnly #MemoDiscount [ngClass]="{'disabledDiv':memoSerial > 0}" [disabled]="memoSerial > 0"
            (change)="onMemosValueChanged()" formControlName="totalMemosValue" class="form-control form-control-sm" />
        </div>
      </div>
      <div class="col-sm-12 col-md-2">
        <div class="form-group">
          <label>{{'NOTES' | translate}}</label>
          <input type="text" [ngClass]="{'disabledDiv':memoSerial > 0}" [disabled]="memoSerial > 0"
            formControlName="memoNotes" class="form-control form-control-sm" />
        </div>
      </div>

    </div>
  </form>



</div>
<div *ngIf="transType != 39" [hidden]="notPayedServices.length == 0">
  <div class="title-tab-step text-center my-0 mt-2">
    {{ "NotPayedVisitServices" | translate }}
  </div>
  <div class="pt-2">
    <table class="blue-header table table-striped table-bordered">
      <thead>
        <tr>
          <th>{{ "ExcludeService" | translate }}
            <input type="checkbox" #toggle (click)="selectAll(toggle.checked,notPayedServices)" />
          </th>
          <th>{{ "CODE" | translate }}</th>
          <th>{{ "SERVICENAME" | translate }}</th>
          <th>{{ "STATE" | translate }}</th>
          <th>{{ "BILLITEM" | translate }}</th>
          <th>{{ "COUNT" | translate }}</th>
          <th>{{ "VisitDate" | translate }}</th>
          <th>{{ "Price" | translate }}</th>
          <th>{{ "NetPrice" | translate }}</th>
          <th>{{ "SHAREDPRICE" | translate }}</th>
          <th>{{ "SHAREDVAT" | translate }}</th>
          <th>{{ "PATPRICE" | translate }}</th>
          <th>{{ "PATVAT" | translate }}</th>
          <!--<th>{{'Paid' | translate}}</th>-->
          <th>{{ "CFDISCOUNTPERCENT" | translate }}</th>
          <th>{{ "PAYEDVALUE" | translate }}</th>
          <!--<th>{{'Discount' | translate}}</th>-->
          <th>{{ "PatPriceAfterDiscount" | translate }}</th>
          <th>{{ "LASTPAYEDVALUE" | translate }}</th>

          <th>{{ "RemainingPrice" | translate }}</th>
          <th>{{ "APPROVALSTATUS" | translate }}</th>
          <th>{{ "ACTION" | translate }}</th>
        </tr>
      </thead>
      <tbody *ngIf="notPayedServices">
        <tr *ngFor="let notPayedService of notPayedServices; let i = index" [ngClass]="{
            notpayedServices: notPayedService.payed == null,
            partialypayedServices: notPayedService.payed == 2
          }">
          <td (click)="RowDisabled(notPayedService, i)">
            <input type="checkbox" [(ngModel)]="notPayedService.disabled" />
          </td>
          <td>{{ notPayedService.customServiceCode }}</td>
          <td>
            {{
            translate.currentLang == "ar"
            ? notPayedService.serviceNameAr
            : notPayedService.serviceNameEn
            }}
          </td>
          <td>
            {{
            translate.currentLang == "ar"
            ? notPayedService.servStatusNameAr
            : notPayedService.servStatusNameEn
            }}
          </td>
          <td>
            {{
            translate.currentLang == "ar"
            ? notPayedService.billItemAr
            : notPayedService.billItemEn
            }}
          </td>
          <td>{{ notPayedService.count }}</td>
          <td>{{ notPayedService.regDate | date : "short" }}</td>
          <td>{{ notPayedService.price | number : "1.1-2" }}</td>
          <td>{{ notPayedService.netPrice | number : "1.1-2" }}</td>
          <td>{{ notPayedService.sharedPrice | number : "1.1-2" }}</td>
          <!-- <td>{{notPayedService.displaySharedPrice}}</td> -->
          <td>{{ notPayedService.sharedVat | number : "1.1-2" }}</td>
          <td>{{ notPayedService.patPrice | number : "1.1-2" }}</td>
          <td>{{ notPayedService.patVat | number : "1.1-2" }}</td>
          <!--<td>{{notPayedService.paid}}</td>-->
          <td>
            <div class="row">
              <div class="col-sm-6 col-md-6" [hidden]="discountType == 1">
                <div class="form-group">
                  <div class="input-group input-group-sm">
                    <sanabel-selectize appcode="40" [(ngModel)]="notPayedService.percentOrValueType"
                      (clicked)="onPvRowClicked($event, i, 'notPayedServices')" [simpleView]="true" 
                      [ngModelOptions]="{standalone: true}"
                      >
                      <!--
                      [ngClass]="{disabledDiv:(showLoyaltyPoint&&notPayedService.disableServiceOrItem)}"-->
                    </sanabel-selectize>
                  </div>
                </div>
              </div>
              <div class="col-sm-6 col-md-6">
                <div class="form-group">
                  <!-- (mouseenter)="getRowPriceAfterDiscount(notPayedService.discountValue,i,'notPayedServices')" -->
                  <div class="input-group input-group-sm">
                    <!-- {{notPayedService.discountValue}} -->
                    <input class="form-control" numbersOnly [(ngModel)]="notPayedService.discountValue" (change)="
                        getRowPriceAfterDiscount(
                          notPayedService.discountValue,
                          i,
                          'notPayedServices'
                        )
                      " [disabled]="notPayedService.disabled || discountType == 1" />
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td>
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <div class="input-group input-group-sm">
                    <!-- (mouseenter)="GetTotalPayedPrice(i)" -->
                    <input class="form-control" [(ngModel)]="notPayedService.payedValue" [disabled]="
                        notPayedService.disabled ||
                        partialyPaymentPrev == 0 ||
                        notPayedService.sharedPrice > 0 ||
                        PossibilityPartialPayment == 2
                      " (change)="GetTotalPayedPrice(i)" numbersOnly />
                  </div>
                </div>
              </div>
            </div>
          </td>
          <!--<td>{{notPayedService.disVal}}</td>-->
          <td>{{ notPayedService.valueAfterDiscount }}</td>
          <td>{{
            notPayedService.lastPayed }}</td>

          <td>{{ notPayedService.remainingPrice }}</td>
          <td>
            {{
            translate.currentLang == "ar"
            ? notPayedService.approvalStatusAr
            : notPayedService.approvalStatusEn
            }}
          </td>
          <td>
            <span>
              <icon-action (clicked)="getServiceDiscount(notPayedService)" [appCodes]="[404]">
              </icon-action>
            </span>
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="notPayedServices">
        <tr>
          <td colspan="6">{{ "TOTAL" | translate }}</td>
          <td>{{ totalServices.totalPrice | number : "1.1-2" }}</td>
          <td>{{ totalServices.totalNetPrice | number : "1.1-2" }}</td>
          <td>{{ totalServices.totalSharedPrice | number : "1.1-2" }}</td>
          <td>{{ totalServices.totalSharedVat | number : "1.1-2" }}</td>
          <td>{{ totalServices.totalPatPrice | number : "1.1-2" }}</td>
          <td>{{ totalServices.totalPatVat | number : "1.1-2" }}</td>
          <!--<td>{{totalServices.totalPaid}}</td>-->
          <td></td>
          <td>{{ totalServices.totalPayedValue | number : "1.1-2" }}</td>
          <!--<td>{{totalServices.totalPatPrice - totalServices.totalAfterDiscount}}</td>-->
          <td>{{ totalServices.totalAfterDiscount | number : "1.1-2" }}</td>
          <td>{{ totalServices.totalLastPayed | number : "1.1-2" }}</td>
          <td>{{ totalServices.totalRemainingPrice | number : "1.1-2" }}</td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
<div [hidden]="notPayedItems.length == 0">
  <div class="title-tab-step text-center my-0 mt-2">
    {{ "NOTPAYEDPRODUCTS" | translate }}
  </div>
  <div class="row p-0 px-3 pt-2">
    <table class="blue-header table table-striped table-bordered">
      <thead>
        <tr>
          <th>{{ "EXCLUDEITEM" | translate }}</th>
          <th>{{ "CODE" | translate }}</th>
          <th>{{ "ITEMNAME" | translate }}</th>
          <th>{{ "BILLITEM" | translate }}</th>
          <th>{{ "COUNT" | translate }}</th>
          <th *ngIf="transType != 39">{{ "VisitDate" | translate }}</th>
          <th>{{ "Price" | translate }}</th>
          <th>{{ "NetPrice" | translate }}</th>
          <th *ngIf="transType != 39">{{ "SHAREDPRICE" | translate }}</th>
          <th *ngIf="transType != 39">{{ "SHAREDVAT" | translate }}</th>
          <th>{{ "PATPRICE" | translate }}</th>
          <th>{{ "PATVAT" | translate }}</th>

          <!--<th>{{'Paid' | translate}}</th>-->
          <th>{{ "CFDISCOUNTPERCENT" | translate }}</th>
          <th *ngIf="transType != 39">{{ "PAYEDVALUE" | translate }}</th>

          <!--<th>{{'Discount' | translate}}</th>-->
          <th>{{ "PatPriceAfterDiscount" | translate }}</th>
          <th *ngIf="transType != 39">{{ "RemainingPrice" | translate }}</th>
        </tr>
      </thead>
      <tbody *ngIf="notPayedItems">
        <tr *ngFor="let notPayedItem of notPayedItems; let i = index" [ngClass]="{
            notpayedServices: notPayedItem.payed == null,
            partialypayedServices: notPayedItem.payed == 2
          }">
          <td>
            <input type="checkbox" (click)="RowDisabled(notPayedItem, -1)" />
          </td>
          <td>{{ notPayedItem.itemCode }}</td>
          <td>
            {{
            translate.currentLang == "ar"
            ? notPayedItem.itemNameAr
            : notPayedItem.itemNameEn
            }}
          </td>
          <td>
            {{
            translate.currentLang == "ar"
            ? notPayedItem.billItemAr
            : notPayedItem.billItemEn
            }}
          </td>
          <td>{{ notPayedItem.count }}</td>
          <td *ngIf="transType != 39">
            {{ notPayedItem.regDate | date : "short" }}
          </td>
          <td>{{ notPayedItem.price | number : "1.1-2" }}</td>
          <td>{{ notPayedItem.netPrice | number : "1.1-2" }}</td>
          <td *ngIf="transType != 39">
            {{ notPayedItem.displaySharedPrice | number : "1.1-2" }}
          </td>
          <td *ngIf="transType != 39">
            {{ notPayedItem.sharedVat | number : "1.1-2" }}
          </td>
          <td>{{ notPayedItem.patPrice | number : "1.1-2" }}</td>
          <td>{{ notPayedItem.patVat | number : "1.1-2" }}</td>
          <!--<td>{{notPayedItem.paid}}</td>-->
          <td>
            <div class="row">
              <div class="col-sm-6 col-md-6" [hidden]="discountType == 1">
                <div class="form-group">
                  <div class="input-group input-group-sm">
                    <sanabel-selectize appcode="40" [(ngModel)]="notPayedItem.percentOrValueType"
                      (clicked)="onPvRowClicked($event, i, 'notPayedItems')" [simpleView]="true">
                      <!--
                      [ngClass]="{disabledDiv:(showLoyaltyPoint&&notPayedItem.disableServiceOrItem)}"-->
                    </sanabel-selectize>
                  </div>
                </div>
              </div>
              <!-- " (mouseenter)="
              getRowPriceAfterDiscount(
                notPayedItem.discountValue,
                i,
                'notPayedItems'
              ) -->
              <div class="col-sm-6 col-md-6">
                <div class="form-group">
                  <div class="input-group input-group-sm">
                    <input class="form-control" numbersOnly [(ngModel)]="notPayedItem.discountValue" (keyup)="
                        getRowPriceAfterDiscount(
                          notPayedItem.discountValue,
                          i,
                          'notPayedItems'
                        )
                     
                      " [disabled]="notPayedItem.disabled || discountType == 1" />
                  </div>
                </div>
              </div>
            </div>
          </td>
          <td *ngIf="transType != 39">
            <div class="row">
              <div class="col">
                <div class="form-group">
                  <div class="input-group input-group-sm">
                    <input class="form-control" [(ngModel)]="notPayedItem.payedValue" [disabled]="
                        notPayedItem.disabled ||
                        partialyPaymentPrev == 0 ||
                        notPayedItem.sharedPrice > 0 ||
                        PossibilityPartialPayment == 2
                      " (keyup)="GetTotalPayedPrice(i)" (mouseenter)="GetTotalPayedPrice(i)" numbersOnly />
                  </div>
                </div>
              </div>
            </div>
          </td>
          <!--<td>{{notPayedItem.disVal}}</td>-->
          <td>{{ notPayedItem.valueAfterDiscount | number : "1.1-2" }}</td>
          <td *ngIf="transType != 39">
            {{ notPayedItem.remainingPrice | number : "1.1-2" }}
          </td>
        </tr>
      </tbody>
      <tfoot *ngIf="notPayedItems">
        <tr>
          <td [attr.colspan]="transType != 39 ? 6 : 5">
            {{ "TOTAL" | translate }}
          </td>
          <td>{{ totalItems.totalPrice | number : "1.1-2" }}</td>
          <td>{{ totalItems.totalNetPrice | number : "1.1-2" }}</td>
          <!-- <td *ngIf="transType != 39">{{totalItems.totalSharedPrice}}</td> -->
          <td *ngIf="transType != 39">
            {{ totalItems.totalDisplaySharedPrice | number : "1.1-2" }}
          </td>
          <td *ngIf="transType != 39">
            {{ totalItems.totalSharedVat | number : "1.1-2" }}
          </td>
          <td>{{ totalItems.totalPatPrice | number : "1.1-2" }}</td>
          <td>{{ totalItems.totalPatVat | number : "1.1-2" }}</td>
          <!--<td>{{totalItems.totalPaid}}</td>-->
          <td></td>
          <td *ngIf="transType != 39">
            {{ totalItems.totalPayedValue | number : "1.1-2" }}
          </td>
          <!--<td>{{totalItems.totalPatPrice - totalItems.totalAfterDiscount}}</td>-->
          <td>{{ totalItems.totalAfterDiscount | number : "1.1-2" }}</td>
          <td *ngIf="transType != 39">
            {{ totalItems.totalRemainingPrice | number : "1.1-2" }}
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
<div class="container-fluid" [hidden]="showSave == 0">
  <div class="row">
    <div class="col">
      <btns-ctrl #btnCtrl1 [paramsArr]="controlsParams" [disabled]="cashierTransForm.invalid"
        (clicked)="onClicked($event)"></btns-ctrl>
    </div>
    <!-- <div class="col text-center">
      <button mat-raised-button color="primary" [class.spinnerBtn]="loading" [disabled]="loading"
        (click)="onClicked(1)"><span class="fas fa-save"></span> Save</button>
    </div> -->
  </div>
</div>
<!--chequeDetailPopup-->

<ng-template #chequeDetailPopup let-c="close">
  <div class="modal-header">
    <h2 class="modal-title">{{ "ChequeDetail" | translate }}</h2>
    <button type="button" class="fa fa-close" aria-label="Close" (click)="cancelChequePopup(c)"></button>
  </div>
  <div class="modal-body">
    <sanabel-chequeDetail [popupClose]="c" [chequeType]="1"></sanabel-chequeDetail>
  </div>
</ng-template>

<!--visaDetailPopup-->
<ng-template #visaDetailPopup let-c="close">
  <div class="modal-header">
    <h2 class="modal-title">{{ "VisaDetail" | translate }}</h2>
    <button type="button" class="fa fa-close" aria-label="Close" (click)="cancelVisaPopup(c)"></button>
  </div>
  <div class="modal-body">
    <!--[visaType]="1"   وارد  -->
    <sanabel-visaDetail [popupClose]="c" [visaType]="1"></sanabel-visaDetail>
  </div>
</ng-template>

<ng-template #bankTransFromPopup let-c="close">
  <div class="modal-header">
    <h2 class="modal-title">{{ "BANKTRANSFORMER" | translate }}</h2>
    <button type="button" class="fa fa-close" aria-label="Close" (click)="onpopup2Close(c)"></button>
  </div>
  <div class="modal-body">
    <div class="container-fluid">

      <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'TRANSFROM' | translate }}</label>
            <sanabel-selectize appcode="1023" [(ngModel)]="bankTranFromerObj.transFromCode" [simpleView]="true">
            </sanabel-selectize>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'TRANSTO' | translate }}</label>
            <sanabel-selectize appcode="1050" [SearchKeys]="{branchFlag:1,Type:1}"
              [(ngModel)]="bankTranFromerObj.transToCode" [simpleView]="true">
            </sanabel-selectize>
          </div>
        </div>
        <div class="col-sm-3">
          <div class="form-group">
            <label>{{'TRANSDATE' | translate}}</label>
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="{{'DATEFORMAT' | translate}}"
                [(ngModel)]="bankTranFromerObj.transDate" ngbDatepicker #FDD="ngbDatepicker">
              <div class="input-group-addon" (click)="FDD.toggle()">
                <i class="fa fa-calendar"></i>
              </div>
            </div>
          </div>
        </div>

      </div>



      <div class="row">
        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'VALUE' | translate }}</label>
            <input numbersOnly class="form-control form-control-sm" [(ngModel)]="bankTranFromerObj.value" />
          </div>
        </div>
        <!-- <div class="col-sm-3">
              <div class="form-group">
                  <label>{{ 'CURRENCY' | translate }}</label>
                  <sanabel-selectize [disabled]="disableVal == 1" appcode="1001"
                      (clicked)="currencyClicked($event)" formControlName="currency" [simpleView]="true">
                  </sanabel-selectize>
              </div>
          </div> -->
        <!-- <div class="col-sm-3">
              <div class="form-group">
                  <label>{{ 'FACTOR' | translate }}</label>
                  <input numbersOnly class="form-control form-control-sm" formControlName="currencyFactor" />
              </div>
          </div> -->
        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'Notes' | translate }}</label>
            <input type="text" class="form-control form-control-sm" [(ngModel)]="bankTranFromerObj.notes" />
          </div>
        </div>


        <div class="col-sm-3">
          <div class="form-group">
            <label>{{ 'REFERENCENUMBER' | translate }}</label>
            <input numbersOnly class="form-control form-control-sm" [(ngModel)]="bankTranFromerObj.referenceNumber" />
          </div>
        </div>
      </div>
      <div class="container-fluid">
        <div class="row">
          <div class="col">
            <btns-ctrl [appCodes]="[1]" (clicked)="saveBankTransform()"></btns-ctrl>
          </div>
        </div>
      </div>

    </div>
  </div>
</ng-template>
<ng-template #couponDetailPopup let-c="close">
  <div class="modal-header">
    <h2 class="modal-title">{{ "couponDetail" | translate }}</h2>
    <button type="button" class="fa fa-close" aria-label="Close" (click)="cancelCouponPopup(c)"></button>
  </div>
  <div class="modal-body">
    <couponDetail [popupClose]="c" (couponClose)="onCouponPopupClose($event)"></couponDetail>
  </div>
</ng-template>
<div>
  <block-modal-container #popup (close)="onpopupClose($event)">
    <ng-container class="modal-title">
      <h2>
        {{ popupHeader | translate }}
        {{ cashierTransForm.get("cashAmmount").value }}
      </h2>
    </ng-container>
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>
<div>

  <block-modal-container #DiscountServicesRequest (close)="onpopupClose($event)">
    <ng-container class="modal-title">
    </ng-container>
    <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
  </block-modal-container>
</div>

<ng-template #popuppp let-c="close" let-d="dismiss">
  <div class="d-flex modal-header">
    <h2 style="width: 95%" class="text-center modal-title">
      {{ "CONFIRMATIONFORMSAVE" | translate }}
    </h2>
    <button style="width: 5%" type="button" class="fa fa-close" aria-label="Close"
      (click)="cancelConfrimationPopup(c)"></button>
  </div>
  <div class="modal-body p-2">
    <form [formGroup]="confirmationPopupForm">
      <div class="row">
        <div class="d-flex form-group col-4">
          <label>{{ "CashAmmount" | translate }}</label>
          <input type="text" class="form-control" formControlName="cash" />
        </div>
        <div class="d-flex form-group col-4">
          <label>{{ "ChequeAmmount" | translate }}</label>
          <input type="text" class="form-control" formControlName="cheque" />
        </div>
        <div class="d-flex form-group col-4">
          <label>{{ "VisaAmmount" | translate }}</label>
          <input type="text" class="form-control" formControlName="visa" />
        </div>
      </div>
      <div class="row">
        <div class="col">
          <btns-ctrl [appCodes]="[1]" (clicked)="onConfrimationPopupSave(c)"></btns-ctrl>
        </div>
      </div>
    </form>
  </div>
</ng-template>